const $ = require('jquery');
window.addEventListener('load', function () {
  const $form = $('#prerequisites-form');
  const $template = $('#prerequisites-template');
  const $raw = $form.find(':input[name=prerequisites]');

  function jsonToForms() {
    $form.find('.prerequisites-group:visible').remove();

    Object.entries(JSON.parse($raw.val())).forEach(([group, types]) => {
      const iden = `prerequisites_${group}`;
      const $clone = $template.clone().removeClass('hidden');

      $clone.removeAttr('id').attr('data-group-index', group);
      $clone.find('label').attr('for', iden);
      $clone.find('label').text(`Vorbedingungsgruppe ${group}`);
      $clone.find('option').each(function handler() {
        const $this = $(this);
        if (types.indexOf(Number($this.val())) > -1) {
          $this.attr('selected', 'selected');
        }
      });

      $form.append($clone);
    });
  }

  function appendToRaw(arr) {
    const currentVal = JSON.parse($raw.val());
    $raw.val(JSON.stringify(currentVal.concat([arr])));
  }

  function formsToJson() {
    $raw.val('[]');
    $form.find('.prerequisites-group:visible').each(function handler() {
      const $this = $(this);
      const $select = $this.find('select');
      const chosen = $select.val().map((v) => Number(v));

      appendToRaw(chosen);
    });
  }

  if ($form.length) {
    jsonToForms();

    $form.on('change', 'select', () => {
      formsToJson();
    });

    $('.prerequisites-add').on('click', () => {
      appendToRaw([]);
      jsonToForms();
    });

    $form.on('click', '.prerequisites-remove', function handler() {
      $(this).parents('.prerequisites-group').remove();
      formsToJson();
    });
  }
});
